export default __webpack_public_path__ + "static/media/fishlike_spaceship.70507da6.png";